.root::after {
    background-color: light-dark(
        var(--mantine-color-gray-2),
        var(--mantine-color-dark-5)
    );
}
